import { request, METHOD } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/* 获取活动管理列表数据（#36） */
export function getActivityList(data) {
  return request("".concat(BASE_URL) + "/activity/list", METHOD.GET, data);
}
/*  获取活动基础信息数据（#10003） */
export function getActivityDetail(activityId) {
  return request("".concat(BASE_URL) + "/activity/detail/" + activityId, METHOD.GET);
}

/* 更新活动管理的基础信息数据（#10004） */
export function updateActivityDetail(data) {
  return request("".concat(BASE_URL) + "/activity/detail", METHOD.PUT, data);
}

/*  获取活动商品基础信息数据（#10002） */
export function getActivityProduct(activityId) {
  return request("".concat(BASE_URL) + "/activity/goods/detail/" + activityId, METHOD.GET);
}

/* 更新活动管理商品信息 (#10001)*/
export function updateActivityPouduct(data) {
  return request("".concat(BASE_URL) + "/activity/goods/detail", METHOD.PUT, data);
}

// 获取活动得意先列表（#10031）
export function getActivityDyx(activityId) {
  return request("".concat(BASE_URL) + "/activity/erpcustomer/detail/" + activityId, METHOD.GET);
}

//更新活动得意先（#10032）
export function updateActivityDyx(activityId, data) {
  return request("".concat(BASE_URL) + "/activity/erpcustomer/detail/" + activityId + '?erpCustomerIds=' + data, METHOD.PUT);
}

/* 新建保存活动信息数据 #44 */
export function addActivity(data) {
  return request("".concat(BASE_URL) + "/activity/addActivity", METHOD.POST, data);
}

/* 上线，下线活动 #38 */
export function updateActivityStatus(data) {
  return request("".concat(BASE_URL) + "/activity/updateStatus", METHOD.PUT, data);
}

/* 删除活动 #10006 */
export function deleteActivity(activityId) {
  return request("".concat(BASE_URL) + "/activity/delete/" + activityId, METHOD.DELETE);
}
export default {
  getActivityList: getActivityList,
  getActivityDetail: getActivityDetail,
  updateActivityDetail: updateActivityDetail,
  getActivityProduct: getActivityProduct,
  updateActivityPouduct: updateActivityPouduct,
  addActivity: addActivity,
  deleteActivity: deleteActivity,
  updateActivityStatus: updateActivityStatus,
  getActivityDyx: getActivityDyx,
  updateActivityDyx: updateActivityDyx
};